import { createSelector } from 'reselect'
import getCheckoutInsuranceQuoteParams, {
  getCheckoutInsuranceBookingProtectionQuoteParams,
  getCheckoutInsuranceQuoteParamsForType,
} from '../request/getCheckoutInsuranceQuoteParams'
import { getInsuranceItems } from './insurance'
import { getInsuranceQuoteKey, getInsuranceQuoteTravellers, insuranceTypeToInsuranceProductType } from 'lib/insurance/insuranceUtils'
import { arrayToObject, nonNullable } from 'lib/array/arrayUtils'
import { isCruiseCheckout } from './cruise'

const getCheckoutSelectedQuotes = createSelector(
  (state: App.State) => getInsuranceItems(state),
  (state: App.State) => getCheckoutInsuranceQuoteParams(state),
  (state: App.State) => getCheckoutInsuranceBookingProtectionQuoteParams(state),
  (state: App.State) => state.insurance.quotes,
  (state: App.State) => isCruiseCheckout(state),
  (items, params, bookingProtectionParams, quotes, isCruiseCheckout): Record<string, App.InsuranceQuote> => {
    const allQuotes = nonNullable(items.map(item => {
      if (item.productId) {
        const productType = item.insuranceType ? insuranceTypeToInsuranceProductType(item.insuranceType) : 'travel-insurance'
        const quoteParams = getCheckoutInsuranceQuoteParamsForType(params, bookingProtectionParams, productType)
        const key = getInsuranceQuoteKey(item.productId, {
          ...quoteParams,
          coverAmount: item.coverageAmount || quoteParams.coverAmount,
          customPolicyIds: item.policyIds,
          type: productType,
          travellers: getInsuranceQuoteTravellers(item, quoteParams.travellers, isCruiseCheckout),
        })

        const quote = quotes[key]
        if (quote) {
          return { item, quote }
        }
      }
    }))

    // now turn it into a item id => quote
    return arrayToObject(allQuotes,
      record => record.item.itemId,
      record => record.quote,
    )
  },
)

export default getCheckoutSelectedQuotes
